<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <v-overlay :opacity="1" :value="overlay">
        <v-progress-circular indeterminate size="64">
          Loading...
        </v-progress-circular>
      </v-overlay>
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Cetak Report</div>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <v-select
                    :items="listKotaDaftar"
                    label="Tao Ying City"
                    required
                    v-model="search_kota"
                    item-text="DESKRIPSI_DATA"
                    item-value="ID_DATA"
                    color="#F9A825"
                  ></v-select>
                </div>
                <div class="col">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search_tgl_awal"
                        label="Tao Ying Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        @blur="search_tgl_awal_raw = parseDate(search_tgl_awal)"
                        v-on="on"
                        color="#F9A825"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="search_tgl_awal_raw"
                      color="#F9A825"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
                <div class="col">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search_tgl_akhir"
                        label="Tao Ying End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        @blur="search_tgl_akhir_raw = parseDate(search_tgl_akhir)"
                        v-on="on"
                        color="#F9A825"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="search_tgl_akhir_raw"
                      color="#F9A825"
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>
              <div class="row">
                <v-btn
                  x-small
                  style="margin: 10px; float: left; background-color: #fcc133"
                  @click="onReset"
                  >Clear</v-btn
                >
                <v-btn
                  x-small
                  style="margin: 10px; float: left; background-color: #3eb650"
                  @click="onPrint"
                  >Print PDF</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import 'fix-date'
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        overlay:false,
        search: '',
        search_kota:'',
        search_tgl_awal:'',
        search_tgl_akhir:'',
        search_tgl_awal_raw:'',
        search_tgl_akhir_raw:'',
        menu2: false,
        menu3: false,
        dialog: false,
        listKotaDaftar:[],
        listGender:[{text:'All Gender',value:''},{text:'Man 男',value:'L'},{text:'Woman 女',value:'P'}],
        listStatus:[],
        listPekerjaan:[],
        listPendidikan:[],
        listGoldar:[],
        listSuku:[],
        users:[],
        isMobile: false,
        editedIndex:'',
        listData: ['','Taoyu','HuangYi'],
        listKotaTgl:[],
        flagEdited:false,
        role:0,
        singleSelect: false,
        dataTables: [],
    }),
    watch: {
        dialog (val) {val || this.close()},
        search_tgl_awal_raw (val) {
            this.search_tgl_awal = this.formatDate(this.search_tgl_awal_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        search_tgl_akhir_raw (val) {
            this.search_tgl_akhir = this.formatDate(this.search_tgl_akhir_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    created () {
        this.initialize()
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else{

            this.isMobile = false;
          }
        },
        onPrint(){
          console.log(this.search_kota);
          console.log(this.search_tgl_awal);
          console.log(this.search_tgl_akhir);
            if(this.search_kota!=='' && this.search_tgl_awal!=='' && this.search_tgl_akhir !==''){
                // alert("here");
                 this.overlay=true;
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_s_report',
                    responseType: 'blob', // important
                    data: {
                      kota: this.search_kota,
                      tanggal_awal: this.search_tgl_awal_raw,
                      tanggal_akhir: this.search_tgl_akhir_raw
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    console.log(response.data);
                       if(response){
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'ReportApprovalTaoyu.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                        this.overlay=false
                }).catch(error=>{
                     Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Kosong'
                            });
                      this.overlay=false
                    // var status = error.response.status
                });             
            }else if (this.search_kota !=='' && this.search_tgl_awal =='' && this.search_tgl_akhir ==''){
                 this.overlay=true;
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_s_report',
                    responseType: 'blob', // important
                    data: {
                      kota: this.search_kota,
                      tanggal_awal: this.search_tgl_awal_raw,
                      tanggal_akhir: this.search_tgl_akhir_raw
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    console.log(response.data);
                       if(response){
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'ReportApprovalTaoyu.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                        this.overlay=false
                }).catch(error=>{
                     Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Kosong'
                            });
                      this.overlay=false
                    // var status = error.response.status
                });
            } else if (this.search_kota=='' && this.search_tgl_awal=='' && this.search_tgl_akhir ==''){
                this.overlay=true;
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_s_report',
                    responseType: 'blob', // important
                    data: {
                      kota: this.search_kota,
                      tanggal_awal: this.search_tgl_awal_raw,
                      tanggal_akhir: this.search_tgl_akhir_raw
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    console.log(response.data);
                       if(response){
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'ReportApprovalTaoyu.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                        this.overlay=false
                }).catch(error=>{
                     Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Kosong'
                            });
                      this.overlay=false
                    // var status = error.response.status
                });
            } 
            else if (this.search_kota=='' && this.search_tgl_awal!=='' && this.search_tgl_akhir !=='') {
                this.overlay=true;
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_s_report',
                    responseType: 'blob', // important
                    data: {
                      kota: this.search_kota,
                      tanggal_awal: this.search_tgl_awal_raw,
                      tanggal_akhir: this.search_tgl_akhir_raw
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    console.log(response.data);
                       if(response){
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'ReportApprovalTaoyu.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                        this.overlay=false
                }).catch(error=>{
                     Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Kosong'
                            });
                      this.overlay=false
                    // var status = error.response.status
                });
            }
            else {
                     Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Harap Isi Kedua Tanggal'
                            });              
            }
        },
        onPrintCSV(){

                this.overlay=true
                axios({
                    method: 'post',
                    url: 'cetak_report',
                    responseType: 'blob', // important
                    data: {
                      kota_dom:this.search_kota_dom,
                      tgl_taoying:this.search_tgl_daftar,
                      kota_tao:this.search_kota,
                      pendidikan:this.search_pendidikan,
                      kelamin:this.search_kelamin,
                      pekerjaan:this.search_job,
                      suku:this.search_suku,
                      status:this.search_status,
                      goldar:this.search_goldar,
                      tipe_data:this.search_tipe_data,
                      tipe: 'csv'
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                        // alert(response.data);
                    if(response){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Report.csv');
                        document.body.appendChild(link);
                        link.click();
                    }
                    this.overlay=false
                }).catch(error => {

                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Data Kosong'
                        });
                 this.overlay=false
                });



        },
        onReset(){
          this.search_tgl_awal=''
          this.search_tgl_akhir=''
          this.search_kota=''
        },
        formatDate (date) {
            if (!date) return null

            return new Date(date).toLocaleDateString('es-CL');
        },
        parseDate (date) {
            if (!date) return null

            return new Date(date).toLocaleDateString('sv-SE')
            // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.editedIndex = -1
            })
        },
        onCloseDialog(){
            this.dialog2=false;
            this.dialog = false;
            this.initialize()
        },
        initialize(){
            axios({
                method: 'post',
                url: 'master_data_by_admin',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
                data:{
                    user_id:  this.$session.get('user_id')
                }
            }).then(response => {

                this.listKota=response.data.Kota_Daftar;
                this.listKotaDaftar=response.data.Kota_Daftar;
                this.listSuku=response.data.Suku;
                this.listStatus=response.data.Status;
                this.listPendidikan=response.data.Pendidikan;
                this.listPekerjaan=response.data.Pekerjaan;
                this.listGoldar=response.data.Golongan_Darah;
                this.listKotaTgl=response.data.Kota_Domisili;

            }).catch(error=>{
                  Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Failed to retrieve data !'
                        });



            });
        },
    },
    components: {

    },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
